(function () {
  'use strict';

  var DESKTOP = {
    right: 20,
    inboxBottom: 24,
    size: 48,
    icon: 22,
    gap: 12,
  };

  var MOBILE = {
    right: 14,
    inboxBottom: 18,
    size: 44,
    icon: 20,
    gap: 10,
  };

  var growaveHidePaused = false;

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function cfg() {
    return isMobile() ? MOBILE : DESKTOP;
  }

  function setStyles(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (key) {
      el.style.setProperty(key, styles[key], 'important');
    });
  }

  function clearStyles(el, keys) {
    if (!el) return;
    keys.forEach(function (key) {
      el.style.removeProperty(key);
    });
  }

  function findGrowaveHost() {
    return document.querySelector('.gw-rd-popup-widget-placeholder');
  }

  function getGrowaveRoot() {
    var host = findGrowaveHost();
    if (!host) return null;
    return host.shadowRoot || host;
  }

  function findGrowaveLauncherShell() {
    var root = getGrowaveRoot();
    if (!root || !root.querySelector) return null;
    return (
      root.querySelector('[class*="gw-rd-popup-widget-launcher"]') ||
      document.querySelector('[class*="gw-rd-popup-widget-launcher"]')
    );
  }

  function findGrowaveLauncherButton() {
    var root = getGrowaveRoot();
    if (!root || !root.querySelector) return null;
    return (
      root.querySelector('button.gw-launcher') ||
      root.querySelector('button[aria-label*="Rewards"]') ||
      root.querySelector('button[aria-label*="rewards"]') ||
      root.querySelector('[class*="gw-rd-popup-widget-launcher"] button') ||
      root.querySelector('[class*="gw-launcher"]')
    );
  }

  function findInboxHost() {
    return (
      document.querySelector('shopify-agent') ||
      document.querySelector('inbox-online-store-chat') ||
      document.querySelector('shopify-chat') ||
      document.getElementById('shopify-chat') ||
      document.getElementById('ShopifyChat')
    );
  }

  function collectShadowRoots(node, depth, limit) {
    if (!node || depth > limit) return [];
    var roots = [];
    var sr = node.shadowRoot;
    if (sr) {
      roots.push(sr);
      var children = sr.querySelectorAll('*');
      for (var i = 0; i < children.length; i++) {
        roots = roots.concat(collectShadowRoots(children[i], depth + 1, limit));
      }
    }
    return roots;
  }

  function findInboxLauncher(host) {
    if (!host) return null;
    if (host.shadowRoot) {
      var activator =
        host.shadowRoot.querySelector('button.activator') ||
        host.shadowRoot.querySelector('button[class*="activator"]');
      if (activator) return activator;
    }

    var roots = [host.shadowRoot, host].concat(collectShadowRoots(host, 0, 4));
    var selectors = [
      'button.activator',
      'button[class*="activator"]',
      'button[aria-label*="chat" i]',
      'button[aria-label*="Chat" i]',
      'button[aria-label*="message" i]',
      'button[aria-label]',
      'button',
      '[role="button"]',
      'iframe',
    ];
    var best = null;
    var bestScore = -1;
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (!root || !root.querySelectorAll) continue;
      for (var i = 0; i < selectors.length; i++) {
        var nodes;
        try {
          nodes = root.querySelectorAll(selectors[i]);
        } catch (e) {
          continue;
        }
        for (var n = 0; n < nodes.length; n++) {
          var el = nodes[n];
          var rect = el.getBoundingClientRect();
          if (rect.width < 24 || rect.height < 24) continue;
          if (rect.width > 96 || rect.height > 96) continue;
          var score =
            (window.innerWidth - rect.right < 140 ? 50 : 0) +
            (window.innerHeight - rect.bottom < 180 ? 50 : 0) +
            (Math.abs(rect.width - rect.height) < 12 ? 30 : 0) +
            (100 - i);
          if (score > bestScore) {
            bestScore = score;
            best = el;
          }
        }
      }
    }
    return best;
  }

  function isVisiblyOpenPanel(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity || '1') < 0.05) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 260 && rect.height > 260;
  }

  function isInboxOpen(host, launcher) {
    if (!host) return false;
    if (host.getAttribute('aria-expanded') === 'true') return true;
    if (launcher && launcher.getAttribute('aria-expanded') === 'true') return true;

    var hostTag = host.tagName ? host.tagName.toLowerCase() : '';
    var hostIsAgent = hostTag === 'shopify-chat' || hostTag === 'shopify-agent';

    if (hostIsAgent && host.shadowRoot) {
      var activator = host.shadowRoot.querySelector('button.activator');
      var runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
      if (activator && !runtime) return false;
      if (runtime) {
        var roots = [runtime.shadowRoot, runtime].filter(Boolean);
        for (var r = 0; r < roots.length; r++) {
          var root = roots[r];
          if (!root || !root.querySelectorAll) continue;
          var panels = root.querySelectorAll('[role="dialog"], .panel, iframe');
          for (var i = 0; i < panels.length; i++) {
            if (isVisiblyOpenPanel(panels[i])) return true;
          }
        }
        if (activator) return false;
      }
    }

    if (!hostIsAgent) {
      var hostRect = host.getBoundingClientRect();
      if (hostRect.width > 260 && hostRect.height > 260) return true;
    }

    var deepRoots = [host].concat(collectShadowRoots(host, 0, 4));
    for (var dr = 0; dr < deepRoots.length; dr++) {
      var deepRoot = deepRoots[dr];
      if (!deepRoot || !deepRoot.querySelectorAll) continue;
      var candidates = deepRoot.querySelectorAll(
        '[role="dialog"], iframe, [part*="window"], [class*="window"], [class*="panel"], [class*="messenger"]'
      );
      for (var ci = 0; ci < candidates.length; ci++) {
        if (isVisiblyOpenPanel(candidates[ci])) return true;
      }
    }
    return false;
  }

  function hideTeasersForInbox(hide) {
    var nodes = [
      document.getElementById('ulefone-floating-dock'),
      document.querySelector('.floating-dock'),
    ];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el) continue;
      if (hide) {
        setStyles(el, {
          display: 'none',
          opacity: '0',
          visibility: 'hidden',
          'pointer-events': 'none',
          'z-index': '1',
        });
      } else {
        clearStyles(el, ['display', 'opacity', 'visibility', 'pointer-events', 'z-index']);
      }
    }
  }

  function applyDockSlot(right, bottom, size, gap) {
    var dock = document.getElementById('ulefone-floating-dock');
    var dockBottom = bottom + size + gap;
    var targets = [document.documentElement, dock];
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (!el) continue;
      el.style.setProperty('--fd-right', right + 'px');
      el.style.setProperty('--fd-bottom', dockBottom + 'px');
      el.style.setProperty('--fd-size', size + 'px');
      el.style.setProperty('--fd-gap', gap + 'px');
    }
  }

  function ensureInboxShadowCss(host, c) {
    if (!host || !host.shadowRoot) return;
    var id = 'ulefone-inbox-align-style';
    var style = host.shadowRoot.getElementById(id);
    if (!style) {
      style = document.createElement('style');
      style.id = id;
      host.shadowRoot.appendChild(style);
    }
    style.textContent =
      'button.activator,button[class*="activator"]{' +
      'position:fixed!important;' +
      'right:' +
      c.right +
      'px!important;' +
      'bottom:' +
      c.inboxBottom +
      'px!important;' +
      'left:auto!important;' +
      'top:auto!important;' +
      'width:' +
      c.size +
      'px!important;' +
      'height:' +
      c.size +
      'px!important;' +
      'min-width:' +
      c.size +
      'px!important;' +
      'min-height:' +
      c.size +
      'px!important;' +
      'border-radius:50%!important;' +
      'margin:0!important;' +
      'transform:none!important;' +
      'box-sizing:border-box!important;' +
      '}';
  }

  function pinInboxChip(host, launcher, c) {
    if (!host && !launcher) return false;
    var chip = launcher;
    if (!chip && host && host.shadowRoot) {
      chip = host.shadowRoot.querySelector('button.activator');
    }

    if (host) {
      var tag = host.tagName.toLowerCase();
      var hr = host.getBoundingClientRect();
      var hostLooksLikeChip = hr.width > 0 && hr.width <= 96 && hr.height > 0 && hr.height <= 96;
      if (hostLooksLikeChip || tag === 'inbox-online-store-chat') {
        setStyles(host, {
          position: 'fixed',
          right: c.right + 'px',
          bottom: c.inboxBottom + 'px',
          left: 'auto',
          top: 'auto',
          width: c.size + 'px',
          height: c.size + 'px',
          'min-width': c.size + 'px',
          'min-height': c.size + 'px',
          margin: '0',
          transform: 'none',
          'z-index': '2147482991',
        });
      }
    }

    if (chip) {
      setStyles(chip, {
        position: 'fixed',
        right: c.right + 'px',
        bottom: c.inboxBottom + 'px',
        left: 'auto',
        top: 'auto',
        width: c.size + 'px',
        height: c.size + 'px',
        'min-width': c.size + 'px',
        'min-height': c.size + 'px',
        'border-radius': '50%',
        margin: '0',
        transform: 'none',
        'box-sizing': 'border-box',
        'z-index': '2147482991',
      });
      ensureInboxShadowCss(host, c);
    }

    return !!(chip || host);
  }

  function alignDockToInbox(opened) {
    if (opened) return;
    var c = cfg();
    applyDockSlot(c.right, c.inboxBottom, c.size, c.gap);
  }

  function alignInbox() {
    var host = findInboxHost();
    var c = cfg();
    var launcher = host ? findInboxLauncher(host) : null;
    var opened = host ? isInboxOpen(host, launcher) : false;
    document.body.classList.toggle('inbox-open', opened);
    hideTeasersForInbox(opened);

    if (opened && host) {
      setStyles(host, { 'z-index': '2147483646' });
      syncOverlayPriority();
      return true;
    }

    if (host) clearStyles(host, ['z-index']);

    pinInboxChip(host, launcher, c);
    alignDockToInbox(opened);
    syncOverlayPriority();
    return !!(host || launcher);
  }

  var SHELL_HIDE_KEYS = [
    'opacity',
    'visibility',
    'pointer-events',
    'position',
    'right',
    'bottom',
    'left',
    'top',
    'width',
    'height',
    'min-width',
    'min-height',
    'overflow',
    'z-index',
    'transform',
  ];

  function hideGrowaveTeaser() {
    if (growaveHidePaused) return false;
    var shell = findGrowaveLauncherShell();
    if (!shell) return false;

    // Keep real size — collapsing to 1px breaks Growave's second open.
    setStyles(shell, {
      opacity: '0',
      visibility: 'hidden',
      'pointer-events': 'none',
      position: 'fixed',
      right: '-9999px',
      bottom: '0',
      width: '56px',
      height: '56px',
      overflow: 'visible',
      'z-index': '-1',
      transform: 'none',
    });
    return true;
  }

  function restoreShellForClick(shell) {
    clearStyles(shell, SHELL_HIDE_KEYS);
    setStyles(shell, {
      position: 'fixed',
      right: '20px',
      bottom: '24px',
      width: '56px',
      height: '56px',
      opacity: '0.01',
      visibility: 'visible',
      'pointer-events': 'auto',
      overflow: 'visible',
      'z-index': '2147483646',
      transform: 'none',
    });
  }

  function isGrowavePopupOpen() {
    var root = getGrowaveRoot();
    if (!root || !root.querySelector) return false;

    var button = findGrowaveLauncherButton();
    if (button) {
      var expanded = button.getAttribute('aria-expanded');
      if (expanded === 'true') return true;
      if (expanded === 'false') return false;
    }

    var nodes = root.querySelectorAll('[role="dialog"], [class*="popup"], [class*="modal"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cls = String(el.className || '');
      if (cls.indexOf('launcher') !== -1) continue;
      var rect = el.getBoundingClientRect();
      if (rect.width > 120 && rect.height > 120) return true;
    }
    return false;
  }

  function openGrowaveViaHash() {
    try {
      if (window.location.hash === '#rewards-home') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      setTimeout(function () {
        window.location.hash = 'rewards-home';
      }, 0);
      return true;
    } catch (e) {
      return false;
    }
  }

  function dispatchClick(el) {
    if (!el) return false;
    // Only one click — double-firing toggles the popup open then closed.
    try {
      if (typeof el.click === 'function') {
        el.click();
        return true;
      }
    } catch (e1) { /* ignore */ }
    try {
      el.dispatchEvent(
        new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
          composed: true,
        })
      );
      return true;
    } catch (e2) {
      return false;
    }
  }

  function scheduleHideTeaser(delay) {
    setTimeout(function () {
      growaveHidePaused = false;
      hideGrowaveTeaser();
    }, delay);
  }

  function openGrowave() {
    var shell = findGrowaveLauncherShell();
    var button = findGrowaveLauncherButton();

    growaveHidePaused = true;

    if (!shell && !button) {
      openGrowaveViaHash();
      scheduleHideTeaser(800);
      return true;
    }

    if (shell) restoreShellForClick(shell);

    // Already open: do not click again (launcher is a toggle and would close it).
    if (isGrowavePopupOpen()) {
      scheduleHideTeaser(400);
      return true;
    }

    // Click inner button once, then verify; hash is reopen fallback.
    var target = button || shell;
    dispatchClick(target);

    setTimeout(function () {
      if (!isGrowavePopupOpen()) openGrowaveViaHash();
      syncOverlayPriority();
    }, 150);

    scheduleHideTeaser(900);
    setTimeout(function () {
      if (!growaveHidePaused) hideGrowaveTeaser();
      syncOverlayPriority();
    }, 1600);
    syncOverlayPriority();
    return true;
  }

  function isNccOpen() {
    return (
      document.body.classList.contains('new-customer-coupon-popup-open') ||
      !!document.querySelector('.new-customer-coupon-popup__overlay.is-open')
    );
  }

  function isChatbotOpen() {
    return document.body.classList.contains('chatbot-is-open');
  }

  function isMobileNavOpen() {
    return document.documentElement.classList.contains('umn-m-lock');
  }

  function isInboxOpenState() {
    return document.body.classList.contains('inbox-open');
  }

  /**
   * Keep one body flag while any panel is open so CSS can hide all teasers.
   * Also boost Growave host z-index when its popup is open.
   */
  function syncOverlayPriority() {
    var growaveOpen = isGrowavePopupOpen();
    document.body.classList.toggle('growave-open', growaveOpen);

    var anyOpen =
      growaveOpen ||
      isNccOpen() ||
      isChatbotOpen() ||
      isMobileNavOpen() ||
      isInboxOpenState();

    document.body.classList.toggle('ulefone-modal-open', anyOpen);

    var host = findGrowaveHost();
    if (host) {
      if (growaveOpen) {
        setStyles(host, { 'z-index': '2147483646' });
      } else {
        clearStyles(host, ['z-index']);
      }
    }
  }

  function alignAll() {
    hideGrowaveTeaser();
    alignInbox();
    syncOverlayPriority();
  }

  function bindFooterTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-growave]');
      if (!trigger) {
        // Fallback: Support menu link titled "Member Rewards" (user-added footer item)
        var link = e.target.closest('.footer a, footer a');
        if (
          link &&
          link.textContent &&
          link.textContent.trim().toLowerCase() === 'member rewards'
        ) {
          trigger = link;
        }
      }
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      openGrowave();
    });
  }

  var ALIGN_DEBOUNCE_MS = 120;
  var alignTimer = 0;
  var aligning = false;
  var observedHosts = [];
  var hostObserver = null;
  var mountObserver = null;
  var inboxPollTimer = 0;

  function scheduleAlign() {
    if (alignTimer) clearTimeout(alignTimer);
    alignTimer = setTimeout(function () {
      alignTimer = 0;
      if (aligning) {
        scheduleAlign();
        return;
      }
      aligning = true;
      try {
        alignAll();
      } finally {
        // Allow attribute writes from setStyles to settle before re-entry.
        setTimeout(function () {
          aligning = false;
        }, 0);
      }
    }, ALIGN_DEBOUNCE_MS);
  }

  /** Ignore Fast Bundle / unrelated app DOM so their injects do not retrigger align. */
  function isIgnoredAppNode(node) {
    if (!node || node.nodeType !== 1) return true;
    var tag = (node.tagName || '').toLowerCase();
    var id = node.id || '';
    var cls = '';
    if (typeof node.className === 'string') cls = node.className;
    else if (node.getAttribute) cls = node.getAttribute('class') || '';

    var hay = (tag + ' ' + id + ' ' + cls).toLowerCase();
    if (
      hay.indexOf('rbr') !== -1 ||
      hay.indexOf('fastbundle') !== -1 ||
      hay.indexOf('fast-bundle') !== -1 ||
      hay.indexOf('fbp-') !== -1 ||
      hay.indexOf('bogos') !== -1 ||
      hay.indexOf('pagefly') !== -1 ||
      hay.indexOf('judgeme') !== -1 ||
      hay.indexOf('jdgm') !== -1
    ) {
      return true;
    }

    if (typeof node.closest === 'function') {
      try {
        if (
          node.closest(
            '[class*="rbr"],[class*="fastbundle"],[class*="fast-bundle"],[id*="fastbundle"],[class*="bogos"],[class*="pagefly"],[class*="jdgm"]'
          )
        ) {
          return true;
        }
      } catch (e) {
        /* ignore invalid selector edge cases */
      }
    }
    return false;
  }

  function isFloatAlignHost(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.id === 'ulefone-floating-dock') return true;
    if (node.classList && node.classList.contains('floating-dock')) return true;
    if (node.classList && node.classList.contains('gw-rd-popup-widget-placeholder')) return true;
    var tag = node.tagName.toLowerCase();
    if (tag === 'shopify-agent' || tag === 'inbox-online-store-chat' || tag === 'shopify-chat') {
      return true;
    }
    if (node.id === 'shopify-chat' || node.id === 'ShopifyChat') return true;
    var cls = typeof node.className === 'string' ? node.className : '';
    if (cls.indexOf('gw-rd-popup') !== -1) return true;
    return false;
  }

  function mutationNeedsAlign(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var target = m.target;

      if (m.type === 'attributes') {
        if (target === document.body || target === document.documentElement) return true;
        if (isIgnoredAppNode(target)) continue;
        if (isFloatAlignHost(target)) return true;
        // Host subtree (Inbox / Growave open-state attrs)
        for (var h = 0; h < observedHosts.length; h++) {
          if (observedHosts[h] && observedHosts[h].contains && observedHosts[h].contains(target)) {
            return true;
          }
        }
        continue;
      }

      if (m.type === 'childList') {
        var lists = [m.addedNodes, m.removedNodes];
        for (var li = 0; li < lists.length; li++) {
          var nodes = lists[li];
          for (var n = 0; n < nodes.length; n++) {
            var node = nodes[n];
            if (!node || node.nodeType !== 1) continue;
            if (isIgnoredAppNode(node)) continue;
            if (isFloatAlignHost(node)) return true;
          }
        }
      }
    }
    return false;
  }

  function ensureHostObserver() {
    if (!hostObserver) {
      hostObserver = new MutationObserver(function (mutations) {
        if (mutationNeedsAlign(mutations)) scheduleAlign();
      });
    }

    var candidates = [findInboxHost(), findGrowaveHost(), document.getElementById('ulefone-floating-dock')];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el || observedHosts.indexOf(el) !== -1) continue;
      observedHosts.push(el);
      hostObserver.observe(el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-expanded', 'open'],
      });
    }
  }

  function bindInboxWatch() {
    // Clicks inside Inbox (incl. shadow DOM) — re-check open state after animation
    document.addEventListener(
      'click',
      function (e) {
        var host = findInboxHost();
        if (!host) return;
        var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
        var hit = false;
        for (var i = 0; i < path.length; i++) {
          if (path[i] === host) {
            hit = true;
            break;
          }
        }
        if (!hit && host.contains && host.contains(e.target)) hit = true;
        if (!hit) return;
        setTimeout(scheduleAlign, 50);
        setTimeout(scheduleAlign, 300);
        setTimeout(scheduleAlign, 800);
      },
      true
    );

    // Light poll only until Inbox mounts; then rely on scoped host observers.
    var polls = 0;
    inboxPollTimer = setInterval(function () {
      polls += 1;
      ensureHostObserver();
      alignInbox();
      if (findInboxHost() || polls >= 20) {
        clearInterval(inboxPollTimer);
        inboxPollTimer = 0;
        // Occasional open-state check (shadow panels can change without useful attrs)
        inboxPollTimer = setInterval(function () {
          alignInbox();
        }, 2000);
      }
    }, 500);
  }

  function startObservers() {
    alignAll();
    bindFooterTriggers();
    bindInboxWatch();
    ensureHostObserver();

    window.UlefoneGrowave = window.UlefoneGrowave || {};
    window.UlefoneGrowave.open = openGrowave;
    window.UlefoneGrowave.hideTeaser = hideGrowaveTeaser;

    // Bootstrap: find late-mounted Inbox / Growave, then stop.
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      ensureHostObserver();
      scheduleAlign();
      if ((findInboxHost() && findGrowaveHost()) || attempts >= 24) clearInterval(timer);
    }, 500);

    // Body: class flags only + direct-child mounts (no subtree — avoids Fast Bundle noise).
    mountObserver = new MutationObserver(function (mutations) {
      if (!mutationNeedsAlign(mutations)) return;
      ensureHostObserver();
      scheduleAlign();
    });

    mountObserver.observe(document.body, {
      childList: true,
      subtree: false,
      attributes: true,
      attributeFilter: ['class'],
    });

    mountObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    window.addEventListener('resize', scheduleAlign);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObservers);
  } else {
    startObservers();
  }
})();
